export default __webpack_public_path__ + "static/tgg-logo-hero-4366e6e4158993f790d07336b0c58da3.webp";